"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AxiosHttpClient = void 0;
const axios_1 = __importDefault(require("axios"));
class AxiosHttpClient {
  get(endPoint, config) {
    return axios_1.default.get(endPoint, Object.assign(Object.assign({}, config), {
      proxy: false
    }));
  }
}
exports.AxiosHttpClient = AxiosHttpClient;